(() => {
  if (!customElements.get("product-form")) {
    customElements.define(
      "product-form",
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector("form");
          if (this.form) {
            this.form.querySelector("[name=id]").disabled = false;
            this.form.addEventListener(
              "submit",
              this.onSubmitHandler.bind(this)
            );
          }

          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");
        }

        onSubmitHandler(evt) {
          evt.preventDefault();
          if (this.form.getAttribute("data-recharge-widget")) return;
          if (this.submitButton.getAttribute("aria-disabled") === "true")
            return;

          this.handleErrorMessage();

          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.classList.add("loading");
          if (this.querySelector(".loading-overlay__spinner"))
            this.querySelector(".loading-overlay__spinner").classList.remove(
              "hidden"
            );

          const config = fetchConfig("javascript");
          config.headers["X-Requested-With"] = "XMLHttpRequest";
          delete config.headers["Content-Type"];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              "sections",
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append("sections_url", window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          // experiment gs-927
          if (
            window.location.href.includes(
              "55-november-experiment-value-addition-section-checkout-dm"
            )
          ) {
            formData.append("properties[_experiment_gs927]", true);
          }

          // end experiment gs-927
          if (window.location.pathname.includes("-bundle")) {
            formData.append(
              "properties[_bundle_page_path]",
              window.location.pathname
            );
            const sellingPlanInput = this.form.querySelector(
              '[name="selling_plan"]'
            );
            const purchaseType =
              sellingPlanInput && sellingPlanInput.value
                ? "subscription"
                : "one_time";
            formData.append("properties[_purchase_type]", purchaseType);
          }
          config.body = formData;
          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response, true);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response, true);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              if (this.querySelector(".loading-overlay__spinner"))
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
              document.dispatchEvent(new CustomEvent("Cart:Drawer:Changed"));
            });
        }

        handleErrorMessage(errorMessage = false) {
          this.errorMessageWrapper =
            this.errorMessageWrapper ||
            this.querySelector(".product-form__error-message-wrapper");
          if (!this.errorMessageWrapper) return;
          this.errorMessage =
            this.errorMessage ||
            this.errorMessageWrapper.querySelector(
              ".product-form__error-message"
            );

          this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

          if (errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }
      }
    );
  }

  class BundleBuilder extends HTMLElement {
    constructor() {
      super();

      this.maxCount = Number(this.getAttribute("data-max-count"));
      this.minCount = Number(this.getAttribute("data-min-count"));
      this.price = Number(this.getAttribute("data-price")) / 100;
      this.variant = Number(this.getAttribute("data-variant-id"));
      this.cart =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
    }

    params() {
      const timeNowEpoch = Date.now();

      let checkboxes = [
        ...document.querySelectorAll(".bundle-builder--item--checkbox"),
      ];
      let selectedBoxes = checkboxes.filter((el) => {
        return el.checked === true;
      });

      let selections = selectedBoxes.map((box, boxIdx, boxArr) => {
        let data = JSON.parse(
          box.parentNode.parentNode.getAttribute("data-json")
        );
        let qtyElement = box.parentNode.parentNode.querySelector(
          ".bundle-builder--quantity--value"
        );
        let quantity = Number(qtyElement.textContent);

        let options = {
          option1: null,
          option2: null,
          option3: null,
        };

        [
          ...box.parentNode.parentNode.querySelectorAll(
            ".bundle-builder--option--wrapper"
          ),
        ].forEach((optionElment) => {
          let num = optionElment.getAttribute("data-position");
          let selectedElement = optionElment.querySelector(
            ".bundle-builder--option--item.selected"
          );
          let selectedName = selectedElement.textContent.trim();
          options[`option${num}`] = selectedName;
        });

        let variant = data.variants.find((v) => {
          if (
            options.option1 === v.option1 &&
            options.option2 === v.option2 &&
            options.option3 === v.option3
          ) {
            return v;
          }
          return false;
        });

        if (!variant) {
          variant = data.variants.find((v) => v);
        }

        return { variant, quantity };
      });

      let items = selections.map((item) => {
        return {
          id: item.variant.id,
          quantity: item.quantity,
        };
      });

      return [
        {
          id: this.variant,
          properties: {
            __bundle_items: JSON.stringify(items),
            __bundle_id: timeNowEpoch,
          },
        },
      ];
    }

    getSections() {
      return new Promise((resolve, _reject) => {
        return fetch(
          `/?sections=${this.cart
            .getSectionsToRender()
            .map((section) => section.id)
            .join(",")}`,
          {
            credentials: "same-origin",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "xmlhttprequest",
            },
          }
        )
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            return resolve(json);
          })
          .catch(function (err) {
            console.error(err);
          });
      });
    }

    atc(params) {
      return new Promise((resolve, _reject) => {
        return fetch("/cart/add.js", {
          body: JSON.stringify({
            items: modifiedParams,
            sections: this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(","),
          }),
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "xmlhttprequest",
          },
          method: "POST",
        }).then((response) => {
          response.json().then((cart) => {
            this.getSections().then((sections) => {
              resolve(Object.assign({}, cart, { sections }));
            });
          });
        });
      });
    }

    connectedCallback() {
      this.hideNonRelevantComponents();

      this.querySelector(".bundle-builder--atc").addEventListener(
        "click",
        (event) => {
          event.preventDefault();
          let params = this.params();
          this.querySelector(".bundle-builder--atc").disabled = true;
          this.querySelector(".bundle-builder--atc").style.opacity = "0.6";
          this.atc(params).then((res) => {
            setTimeout(() => {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" });
              this.querySelector(".bundle-builder--atc").disabled = false;
              this.querySelector(".bundle-builder--atc").style.opacity = "";
              this.cart.renderContents(res, true);
              if (res.items.length) {
                document
                  .querySelector("cart-drawer")
                  .classList.remove("is-empty");
              }
            }, 300);
          }, false);
        },
        false
      );

      [...this.querySelectorAll(".bundle-builder--option--item")].forEach(
        (element) => {
          element.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              [
                ...element.parentNode.querySelectorAll(
                  ".bundle-builder--option--item"
                ),
              ].forEach((e) => e.classList.remove("selected"));
              element.classList.add("selected");
              this.count();
            },
            false
          );
        }
      );

      [...this.querySelectorAll(".bundle-builder--item--checkbox")].forEach(
        (boxElement) => {
          boxElement.addEventListener(
            "change",
            (event) => {
              if (this.isMax()) {
                this.preventAdd();
                return false;
              } else {
                this.allowAdd();
              }
            },
            false
          );
        }
      );

      this.querySelector(".bundle-builder--item--checkbox").dispatchEvent(
        new Event("change")
      );

      [...this.querySelectorAll(".bundle-builder--quantity--plus")].forEach(
        (plusElement) => {
          plusElement.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              if (this.isMax()) {
                return false;
              }
              let valueElement = plusElement.parentNode.querySelector(
                ".bundle-builder--quantity--value"
              );
              let nval = Number(valueElement.textContent);
              nval++;
              plusElement.parentNode.querySelector(
                ".bundle-builder--quantity--value"
              ).innerHTML = nval;
              if (this.isMax()) {
                this.preventAdd();
              } else {
                this.allowAdd();
              }
            },
            false
          );
        }
      );

      [...this.querySelectorAll(".bundle-builder--quantity--minus")].forEach(
        (plusElement) => {
          plusElement.addEventListener(
            "click",
            (event) => {
              event.preventDefault();
              let valueElement = plusElement.parentNode.querySelector(
                ".bundle-builder--quantity--value"
              );
              let nval = Number(valueElement.textContent);
              nval--;
              if (nval <= 1) {
                nval = 1;
              }
              plusElement.parentNode.querySelector(
                ".bundle-builder--quantity--value"
              ).innerHTML = nval;
              if (this.isMax()) {
                this.preventAdd();
              } else {
                this.allowAdd();
              }
            },
            false
          );
        }
      );
    }

    count() {
      let checkboxes = [
        ...document.querySelectorAll(".bundle-builder--item--checkbox"),
      ];
      let selectedBoxes = checkboxes.filter((el) => {
        return el.checked === true;
      });
      return selectedBoxes
        .map((box) => {
          let val = box.parentNode.parentNode.querySelector(
            ".bundle-builder--quantity--value"
          );
          return Number(val.textContent);
        })
        .reduce((total, item) => {
          return total + item;
        }, 0);
    }

    isMax() {
      if (this.count() < this.minCount || this.count() > this.maxCount) {
        this.querySelector(".bundle-builder--atc").disabled = true;
        this.querySelector(".bundle-builder--atc").style.opacity = "0.6";
      } else {
        this.querySelector(".bundle-builder--atc").disabled = "";
        this.querySelector(".bundle-builder--atc").style.opacity = "";
      }

      if (this.maxCount === this.minCount) {
        if (this.count() === this.maxCount) {
          return true;
        }
      } else {
        if (this.count() >= this.minCount && this.count() <= this.maxCount) {
          return true;
        }
      }

      return false;
    }

    preventAdd() {
      let checkboxes = [
        ...document.querySelectorAll(".bundle-builder--item--checkbox"),
      ];
      let selectedBoxes = checkboxes.filter((el) => {
        return el.checked !== true;
      });
      selectedBoxes.forEach((box) => {
        box.style.opacity = "0.6";
        box.disabled = true;
      });
    }

    allowAdd() {
      let checkboxes = [
        ...document.querySelectorAll(".bundle-builder--item--checkbox"),
      ];
      let selectedBoxes = checkboxes.filter((el) => {
        return el.checked !== true;
      });
      selectedBoxes.forEach((box) => {
        box.style.opacity = "";
        box.disabled = false;
      });
    }

    hideNonRelevantComponents() {
      [...document.querySelectorAll(".product-form__input")].forEach((el) => {
        el.style.display = "none";
      });
    }
  }

  if (!window.customElements.get("bundle-builder")) {
    window.BundleBuilder = BundleBuilder;
    window.customElements.define("bundle-builder", BundleBuilder);
  }
})();
